import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaBoxOpen, FaShoppingCart, FaUsers, FaChartLine } from 'react-icons/fa';
import AdminNav from './AdminNav';

const AdminContainer = styled.div`
  max-width: 1200px;
  margin: 2rem auto;
  padding: 1.5rem;
`;

const Header = styled.div`
  margin-bottom: 2rem;
`;

const Title = styled.h1`
  color: #333;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  color: #666;
  font-size: 1.1rem;
`;

const DashboardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
`;

const DashboardCard = styled(Link)`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  text-decoration: none;
  color: inherit;
  transition: transform 0.3s, box-shadow 0.3s;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }
`;

const CardIcon = styled.div`
  font-size: 2rem;
  color: #C41E3A;
  margin-bottom: 1rem;
`;

const CardTitle = styled.h3`
  margin-bottom: 0.5rem;
  color: #333;
`;

const CardDescription = styled.p`
  color: #666;
  font-size: 0.9rem;
`;

const AdminDashboard = () => {
  return (
    <AdminContainer>
      <Header>
        <Title>Admin Dashboard</Title>
        <Subtitle>Manage your store, products, and orders</Subtitle>
      </Header>
      
      <AdminNav />
      
      <DashboardGrid>
        <DashboardCard to="/admin/products">
          <CardIcon>
            <FaBoxOpen />
          </CardIcon>
          <CardTitle>Products</CardTitle>
          <CardDescription>
            Add, edit, and manage your product inventory
          </CardDescription>
        </DashboardCard>
        
        <DashboardCard to="/admin/orders">
          <CardIcon>
            <FaShoppingCart />
          </CardIcon>
          <CardTitle>Orders</CardTitle>
          <CardDescription>
            View and process customer orders
          </CardDescription>
        </DashboardCard>
        
        <DashboardCard to="/admin/customers">
          <CardIcon>
            <FaUsers />
          </CardIcon>
          <CardTitle>Customers</CardTitle>
          <CardDescription>
            Manage customer accounts and details
          </CardDescription>
        </DashboardCard>
        
        <DashboardCard to="/admin/analytics">
          <CardIcon>
            <FaChartLine />
          </CardIcon>
          <CardTitle>Analytics</CardTitle>
          <CardDescription>
            View sales reports and store statistics
          </CardDescription>
        </DashboardCard>
      </DashboardGrid>
    </AdminContainer>
  );
};

export default AdminDashboard;
